import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Table, Media,Input, Alert, Button, InputGroup, InputGroupAddon, Label, CustomInput } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from 'classnames';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
// Components
import RecentlyActivity from "./RecentlyActivity";
import ShowError from '../Utility/Error';
import AssessmentAdd from './AssessmentAdd';
import DocumentAdd from './DocumentAdd';
import SourceAdd from "./SourceAdd"
import ProfileImageAdd from './ProfileImageAdd';
import VictimVideoAdd from './VictimVideoAdd';
import VideoPlayer from './VideoPlayer';
import UiCarousel from './UiCarousel';
import TestimonyReportEditor from './TestimonyReportEditor';

import S3 from 'react-aws-s3';

import defImg from "../../assets/images/product/prison.jpg";
import { testimonyFormOptionsUrl, victimAddressUrl, victimAssessmentUrl, victimConsentUrl, victimContactUrl, victimDataUrl, victimDetentionUrl, victimDocumentUrl, victimHealthUrl, victimImageUrl, victimOccupationUrl, victimSourceUrl, victimSummaryUrl, victimTravelUrl, victimUrl, victimVideoUrl } from '../../helpers/url';

class TestimonyDetail extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Testimonies", link : "#" },
                { title : "Testimony Details", link : "#" },
            ],
            loading: true,
            success: false,
            successMessage: "",
            error: false,
            errorMessage: "",
            errorStatusCode: 0,
            endpoints: [
				victimUrl,
				victimAddressUrl,
				victimHealthUrl,
				victimDocumentUrl,
				victimDataUrl,
                victimTravelUrl,
                victimDetentionUrl,
                victimContactUrl,
                victimConsentUrl,
                victimAssessmentUrl,
			],
            tagIcons: ["mdi mdi-shield-star-outline", "mdi mdi-factory", "mdi mdi-baby-carriage-off"],
            tags: [],
            tagsDescription: [],
            activeTab: 0,
            activeTab2: '1',
            data: [],
            latestStatusFilterOptions: [],
            tempDocumentDropLocation: [],
            summaryText: "",
            summaryId: 0,
            summaryChanged: false,
            showSummaryEdit: false,
            oId: 0, 
            occupationId: 0,
            occupationSuccess: false,
            showOccupationEdit: false,
            pdfGerenrated: "",
            pdfLink: "https://utjd.org/missing/pdf/aws/victim/",
            videoTestimony: ["https://www.youtube.com/embed/eEhT4mnLaQQ"],
            consentIcons: ["ri-exchange-line", "ri-exchange-line", "ri-exchange-line"],
            showConsentsEdit: false,
            defVideo: "https://www.youtube.com/watch?v=eEhT4mnLaQQ"
        }
        this.toggleTab = this.toggleTab.bind(this);
        this.toggleTab2 = this.toggleTab2.bind(this);
        this.imageShow = this.imageShow.bind(this);
    }

    generatePDF = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;

        let birthPlace = this.state.data[1].find(o => o.type === "Birth Place")
        let occupationName = this.state.formOptions.occupations.find(o => o.occupationId === this.state.occupationId).occupationEN
        const data = "cid="+this.state.victimId+"&userid="+userId
        fetch("https://www.utjd.org/admin/tcpdf/pdfgenerator/missing_person_detailed_save_victim.php", {
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded", "Authorization": accessToken},
            body: data
        }).then(res=>res.text())
        .then(data => {
            this.setState({
                pdfGerenrated: data
            })
        })
    }

    submitSummary = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken
        fetch(victimSummaryUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                summaryId : this.state.summaryId,
                victimId : this.state.victimId,
                userId : userId,
                summary : this.state.summaryText
            })
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                summaryText: data[0].summary,
                summaryId: data[0].summaryId,
                summaryChanged: true,
            })
        })
    } 

    consentsSubmit = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch("link", {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify(
                {
                    verified: this.state.data[0].verified,
                    audioConsent: this.state.data[8][0].accepted,
                    videoConsent: this.state.data[8][1].accepted,
                    dataConsent: this.state.data[8][2].accepted
                }
            )
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                success: true,
                successMessage: "Successfully Changed!",
                showConsentsEdit: false,
            })
        })
    }

    submitOccupation = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
        fetch(victimOccupationUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                oId : this.state.oId,
                victimId : this.state.victimId,
                userId : userId,
                occupationId : parseInt(this.state.occupationId)
            })
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                oId: data.oid,
                occupationSuccess: true,
            })
        })
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab.key) {
            this.setState({
                activeTab: tab.key
            });
        }
    }
    toggleTab2(tab) {
        if (this.state.activeTab2 !== tab) {
            this.setState({
                activeTab2: tab
            });
        }
    }
    imageShow(img, id) {
        var expandImg = document.getElementById("expandedImg" + id.key);
        expandImg.src = img;
    }

    stateHandling = (event) => {
        this.setState({
            [event.target.id]: event.target.value
        })
    }

    consentRadioState = (event) => {
        let data = [...this.state.data]
        switch (event.target.name) {
            case "verified":
                data[0].verified = !data[0].verified
                this.setState({data: data})
                break;
            case "audio":
                data[8][0].accepted = !data[8][0].accepted
                this.setState({data: data})
                break;
            case "video":
                data[8][1].accepted = !data[8][1].accepted
                this.setState({data: data})
                break;
            case "data":
                data[8][2].accepted = !data[8][2].accepted
                this.setState({data: data})
                break;
            default:
                break;
        }
    }

    fetchData = async (endpoint) => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        let dataFetch = await fetch(endpoint, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res => res.json())
        return dataFetch
    }
    
    componentDidMount() {
        try {
        this.setState({ victimId: this.props.location.state.victimId })
        Promise.all([
            this.fetchData(this.state.endpoints[0] + this.props.location.state.victimId + "/"), //.then(res=>res.json()),
            this.fetchData(this.state.endpoints[1] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[2] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[3] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[4] + this.props.location.state.victimId + "/"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[5] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[6] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[7] + this.props.location.state.victimId + "/0"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[8] + this.props.location.state.victimId + "/"),//.then(res=>res.json()),
            this.fetchData(this.state.endpoints[9] + this.props.location.state.victimId + "/0"),
            this.fetchData(testimonyFormOptionsUrl),
            this.fetchData(`${victimSummaryUrl}${this.props.location.state.victimId}/0`),
            this.fetchData(`${victimOccupationUrl}${this.props.location.state.victimId}/0`),
            this.fetchData(`${victimImageUrl}${this.props.location.state.victimId}/0`),
            this.fetchData(`${victimVideoUrl}${this.props.location.state.victimId}/0`),
            this.fetchData(`${victimSourceUrl}${this.props.location.state.victimId}/0`)
        ])
        .then(([
            dataSection1, dataSection2, dataSection3, dataSection4, dataSection5, dataSection6, 
            dataSection7, dataSection8, dataSection9, dataSection10, filterOptions, summary, occupation, photos, videos, sources
        ]) => {
            var dataSectionNumber = [[dataSection1, dataSection5, dataSection5, dataSection5, dataSection5], [dataSection2, dataSection3, dataSection7, dataSection7, dataSection8]]
            var dataSectionKey = [["ethnicityId", "chineseLanguageSkills", "educationLevel", "maritalStatus", "religiosity"], ["codeId", "status", "locationId", "statusId", "placeOfBirthId"]]
            var formOptionsKey = [["ethnicities", "languageSkills", "educations", "maritalStatus", "religiousTypes"], ["landCodes", "healthStatus", "internmentLocations", "victimStatus", "countries"]]
            var formOptionsKeyId = [["id", "lid", "educationId", "mid", "rId"], ["codeId", "hid", "id", "id", "countryId"]]
            var formOptionsValue = [["ethnicityEN", "skillEN", "educationEN", "status_en", "rEN"], ["cityCountyEN", "statusEN", "name", "statusEN", "countryName"]]
            for (let i = 0; i < dataSectionNumber[0].length; i++) {
                dataSectionNumber[0][i] = filterOptions[formOptionsKey[0][i]].find(o => o[formOptionsKeyId[0][i]] === dataSectionNumber[0][i][dataSectionKey[0][i]] && (dataSectionNumber[0][i][dataSectionKey[0][i]] = o[formOptionsValue[0][i]]))?.[formOptionsValue[0][i]];
            }
            for (let i = 0; i < dataSectionNumber[1].length; i++) {
                for (let j = 0; j < dataSectionNumber[1][i].length; j++){
                    if (i === dataSectionNumber[1].length -1) {
                        dataSectionNumber[1][i][j].person.placeOfBirthId = filterOptions.countries.find(o => o.countryId === dataSectionNumber[1][i][j].person.placeOfBirthId).countryName
                    }
                    let _ = filterOptions[formOptionsKey[1][i]].find(o => o[formOptionsKeyId[1][i]] === dataSectionNumber[1][i][j][dataSectionKey[1][i]] && (dataSectionNumber[1][i][j][dataSectionKey[1][i]] = o[formOptionsValue[1][i]]))?.[formOptionsValue[1][i]];
                }
            }
            let section2Type = ["Other", "Birth Place", "Work Place", "Education", "Place of Residence"] // 1, 2...
            let section4Type = ['PASSPORT', 'NATIONALIDCARD', 'OTHERS'] // 1, 2...
            for (let i = 0; i < dataSection2.length; i++) {
                dataSection2[i].type = section2Type[dataSection2[i].type - 1]
            }
            for (let i = 0; i < dataSection4.length; i++) {
                dataSection4[i].type = section4Type[dataSection4[i].type - 1]
            }
            if (!dataSection6.status) {
                for (let i = 0; i < dataSection6.visitedCountriesId.length; i++) {
                    dataSection6.visitedCountriesId[i] = filterOptions.countries.find(o => o.countryId === dataSection6.visitedCountriesId[i]).countryName
                }
            }
            let tags = []
            let tagsDescription = []
            for (let i = 0; i < dataSection10.length; i++) {
                for (let j = 0; j < dataSection10[i].tags.length; j++) {
                    if (!tags.includes(dataSection10[i].tags[j].tagId - 1)) {
                        tags.push(dataSection10[i].tags[j].tagId - 1)
                        tagsDescription.push(dataSection10[i].tags[j].description)
                    }
                }
            }
            this.setState({
                data: [dataSection1, dataSection2, dataSection3, dataSection4, dataSection5, 
                        dataSection6, dataSection7, dataSection8, dataSection9, dataSection10, photos, videos, sources ],
                latestStatusFilterOptions: [...filterOptions.victimStatus],
                formOptions: filterOptions,
                loading: false,
                summaryText: summary[0]?.summary,
                summaryId: summary[0]?.summaryId ? summary[0].summaryId : 0,
                tags: tags,
                tagsDescription: tagsDescription,
                occupationId: occupation?.occupationId ? occupation.occupationId : 0,
                oId: occupation?.oid ? occupation.oid : 0,
            })
        }).catch(err => {
            console.log(err)
            this.setState({
                error: true,
                errorMessage: err.message,
                errorStatusCode: err.status?.code
            })
        })
        }
        catch (err) {
            this.setState({
                error: true,
                errorMessage: err.message,
                errorStatusCode: err.status?.code
            })
        }
        }

        fileDropSubmitToS3 = async (file, sectionName, documentCategory) => {
            const config = {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
                secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
            };
            const ReactS3Client = new S3(config);
            await ReactS3Client.uploadFile(file, 'testimony/' + this.state.victimId + '/' + sectionName + '/' + documentCategory + '/' + file.name)
                .then(data => {
                    if (data && data.location) {
                        console.log(data.location);
                        this.setState({
                            tempDocumentDropLocation: [...this.state.tempDocumentDropLocation, data.location]
                        })
                        this.submitDropDocument(data.location);
                    } else {
                        this.setState({
                            error: true,
                            errorMsg: 'File could not be uploaded',
                        });
                    }
                })
                .catch(err => {
                    this.setState({
                        error: true,
                        errorMsg: err.message,
                    });
                });
        };
    
        submitDropDocument = async (location) => {
            const session = JSON.parse(sessionStorage.getItem('authUser'));
		    const accessToken = session.jwtToken;
            fetch(victimDocumentUrl, {
                method: "POST",
                headers: {"Content-Type": "application/json", "Authorization": accessToken},
                body: JSON.stringify([{
                    type: 5,
                    idNumber: "",
                    s3location: location,
                    notes: "Multiple Drop Documents from Testimony Details Page",
                    issuedBy: "",
                    issuedDate: new Date,
                    victimId: this.state.victimId,
                    documentId: 0
                }])
            }).then(res=>res.json())
            .then(data => {
                console.log(data);
            })
        }
    
        fileDropHandling = async (event, sectionName) => {
            if (event.target.files !== null && event.target.files.length > 0) {
                for (let file of event.target.files) {
                    await this.fileDropSubmitToS3(file, sectionName, 5);
                }
            }
        };

        
    
    render() {
        if (this.state.error) {
            return ( <ShowError errorMessage={this.state.errorMessage} errorStatusCode={this.state.errorStatusCode} redirectTo="/testimonyManager"/> )
        }
        else if (this.state.loading === true) {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <h1 className="h3 mb-3 text-center">Loading</h1>
                        </Container>
                    </div>
                </React.Fragment>
            )
        }
        else {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Testimony Details" breadcrumbItems={this.state.breadcrumbItems} />
                        
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xl={5}>
                                                <div className="product-detail">
                                                    <Row>
                                                        <Col xs={3}>
                                                            <Nav pills className="flex-column" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                            {this.state.data[10].map((each, key) => 
                                                                <NavLink
                                                                className={classnames({ active: this.state.activeTab === {key} })}
                                                                onClick={() => { this.toggleTab({key}); }}>
                                                                    <img src={each.s3location ? each.s3location : defImg} alt={each.description} onClick={() => { this.imageShow(each.s3location ? each.s3location : defImg, {key}) }} className="img-fluid mx-auto d-block tab-img rounded"/>
                                                                </NavLink>
                                                            )}
                                                            </Nav>
                                                        </Col>
                                                        <Col md={8} xs={9}>
                                                            <TabContent activeTab={this.state.activeTab} id="v-pills-tabContent">
                                                                {this.state.data[10].map((each, key) => 
                                                                    <TabPane tabId={key}>
                                                                        <div className="product-img">
                                                                            <img src={each.s3location ? each.s3location : defImg} id={"expandedImg"+key} alt={each.description} className="img-fluid mx-auto d-block"/>
                                                                        </div>
                                                                    </TabPane>
                                                                )}
                                                            </TabContent>
                                                            <Row className="text-center mt-2">
                                                                <Col sm={6}>
                                                                <Link>
                                                                    <div className="product-color-item">
                                                                        <ProfileImageAdd victimId={this.state.victimId}/>
                                                                    </div>
                                                                </Link>
                                                                </Col>
                                                                <Col sm={6}>
                                                                    <Button color="light" block type="button" className="btn-block waves-effect  mt-2 waves-light">
                                                                        <i className="mdi mdi-shopping mr-2"></i>Add Info
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col xl={7}>
                                                <div className="mt-4 mt-xl-3">
                                                    <Link to="#" className="text-primary">{this.state.data[0].birthYear}-{this.state.data[0].birthMonth}-{this.state.data[0].birthDay}, {this.state.data[0].gender === 3 ? "Male" : "Female"}</Link>
                                                    <h5 className="mt-1 mb-3">{this.state.data[0].firstname} {this.state.data[0].lastname} / {this.state.data[0].legalName} / {this.state.data[0].fullnameUEY} </h5>

                                                    <div className="d-inline-flex">
                                                        {/* <div className="text-muted mr-3">
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star mr-1"></span>
                                                        </div> */}
                                                        <div className="text-muted">( {this.state.data[0].visits} views )</div>
                                                    </div>
                                                    <Row>
                                                        <span className="text-danger font-size-12 ml-3">{this.state.data[6].length === 0 ? "" : this.state.data[6].sort(function (a, b) { return a.value - b.value })[0].statusId}</span>
                                                    </Row>
                                                    {this.state.data[1].map((each, key) => 
                                                        <h5 className="mt-2" key={key}>{each.address}, {each.codeId}</h5>
                                                    )}
                                                    <p className="mt-3">Latest:</p>
                                                    <p className="mt-3">{this.state.data[6].length === 0 ? "" : this.state.data[6].sort(function (a, b) { return a.value - b.value })[0].locationId}</p> 
                                                    <hr className="my-4"/>
                                                    <p className="mt-3">Summary:</p>
                                                    <p className="mt-0">
                                                        <Label className="mt-0">{this.state.summaryText}
                                                        </Label>
                                                        <Link><i className="mdi mdi-book-plus-multiple-outline" onClick={()=>{this.setState({showSummaryEdit: !this.state.showSummaryEdit})}}></i></Link>
                                                        {this.state.showSummaryEdit ? 
                                                            <>
                                                            <Input className="mt-1" type="text" onChange={(event) => {this.setState({summaryText: event.target.value})}}></Input>
                                                            <Button className="mt-1" onClick={() => {this.submitSummary()}}>Change</Button>
                                                            </>
                                                            : ""
                                                        }
                                                        {this.state.summaryChanged ? <Alert toggle={(e) => this.setState({summaryChanged: false})} color="success">Successfully Changed!</Alert> : ""}
                                                    </p> 
                                                    <hr className="my-4"/>

                                                    <Row>
                                                        <Col md={6}>
                                                            <div>
                                                                <h5 className="font-size-14"><i className="mdi mdi-location"></i> Get latest info</h5>
                                                                <div className="form-inline">
                                                                    
                                                                    <InputGroup className="mb-3">
                                                                        <Input type="text" className="form-control" placeholder="Subscribe to Latest Information "/>
                                                                        <InputGroupAddon addonType="append">
                                                                          <Button color="light" type="button">Subscribe</Button>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </div>

                                                                {/*<h5 className="font-size-14">Info :</h5>
                                                                 <ul className="list-unstyled product-desc-list">
                                                                    {Object.entries(this.state.data[4])?.map((each, key) =>  {each[0] !== 1 && 
                                                                        <li><i key={key} className="mdi mdi-circle-medium mr-1 align-middle"></i>{each[1]}</li> 
                                                                        }
                                                                    )}
                                                                    <li><i className="mdi mdi-circle-medium mr-1 align-middle"></i> Verifieng the exact location</li>
                                                                    <li><i className="mdi mdi-circle-medium mr-1 align-middle"></i> Bachelor</li>
                                                                    <li><i className="mdi mdi-circle-medium mr-1 align-middle"></i> Married</li>
                                                                    <li><i className="mdi mdi-circle-medium mr-1 align-middle"></i> High Level in Chinese Language</li> 
                                                                </ul>
                                                                  */}
                                                            </div>
                                                        </Col>

                                                        <div>
                                                            <h5 className="font-size-14">Services :</h5>
                                                            <ul className="list-unstyled product-desc-list">
                                                                <Link onClick={this.generatePDF}><li><i className="mdi mdi-sync text-primary mr-1 align-middle font-size-16"></i> Generate PDF</li></Link>
                                                                {this.state.pdfGerenrated !== "" ? <Link to={{ pathname: this.state.pdfLink+this.state.pdfGerenrated }} target="_blank">Open PDF</Link> : ""}
                                                                <li><i className="mdi mdi-currency-usd-circle text-primary mr-1 align-middle font-size-16"></i> Contribute</li>
                                                            </ul>
                                                        </div>
                                                    </Row>

                                                    <Row>
                                                        <Col md={6}>
                                                            <div className="product-color mt-3">
                                                                <h5 className="font-size-14">Other Documents :</h5>
                                                                {this.state.data[3].map((each, key) => 
                                                                    <Link to={{ pathname: each.s3location }} target="_blank">
                                                                        <div className="product-color-item">
                                                                            <img src={each.s3location} alt="Image" className="avatar-md"/>
                                                                        </div>
                                                                        <p>{each.s3location.slice(-3)}</p>
                                                                    </Link>
                                                                )}
                                                                <Link>
                                                                    <div className="product-color-item">
                                                                        <DocumentAdd victimId={this.state.victimId}/>
                                                                    </div>
                                                                    <p>Add</p>
                                                                </Link>
                                                            </div>
                                                        </Col>

                                                        <Col md={6}>
                                                            <div className="product-color mt-3">
                                                                <h5 className="font-size-14">Labels :</h5>
                                                                {this.state.tags.map((each, key) => 
                                                                    <Link  className="ml-1" key={key}>
                                                                        <div className="product-color-item">
                                                                            <div className="avatar-xs">
                                                                            <span className="avatar-title bg-transparent text-body"><i className={this.state.tagIcons[each]}></i></span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Label htmlFor="example-text-input" className="col-md-10 col-form-label">
														Documents Drop Section for multiple files upload. Files will be uploaded without description.
                                                    </Label>	
                                                    <Row>
                                                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">
                                                            Documents Drop
                                                        </Label>
                                                        <Col md={8}>
                                                            <div className="custom-file mb-2">
                                                                <CustomInput
                                                                    type="file" multiple 
                                                                    className="custom-file-input"
                                                                    id="tempDocumentFileDropHolder"
                                                                    onChange={event => {
                                                                        this.fileDropHandling(event, 'drop');
                                                                    }}
                                                                />
                                                                <Label className="custom-file-label" htmlFor="tempDocumentFileDropHolder">
                                                                    Choose files for Drop
                                                                </Label>
                                                            </div>
                                                        </Col>
                                                        <Col md={8}>
                                                            <div className="testimony-file-preview text-center">
                                                                Uploaded files {this.state.tempDocumentDropLocation.length}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    
                                                </div>
                                            </Col>
                                        </Row>

 
                                        <Row>
                                            <Col xl={12}>
                                                <Card>
                                                    <CardBody>
                                                        <TestimonyReportEditor victimId={this.state.victimId}></TestimonyReportEditor>
                                                    </CardBody>
                                                </Card>
                                            </Col> 
                                        </Row>
                                        
                                        <Row>
                                            <RecentlyActivity victimId={this.state.victimId} detention={this.state.data[6]} />
                                            <Col xl={12}>
                                                <Card>
                                                    <CardBody>
                                                        <h4 className="card-title">Video Testimony</h4>
                                                        <p className="card-title-desc">The original video testimony.
                                                        <VictimVideoAdd victimId={this.state.victimId}/>
                                                        </p>
                                                        <VideoPlayer video={this.state.data[11] === undefined || this.state.data[11].length == 0 ? this.state.defVideo : this.state.data[11][0].s3location}/>
                                                        <span>{this.state.data[11] === undefined || this.state.data[11].length == 0 ? "No video testimony is submitted" : this.state.data[11][0].description}</span>
                                                        {this.state.data[11].slice(1).map((each, key) => 
                                                            <NavLink>
                                                                <Link to={{ pathname: each.s3location}} target="_blank"><li><i className="mdi mdi-link-box-variant text-primary mr-1 align-middle font-size-16"></i> {each.s3location ? each.description : ""} </li></Link>
                                                            </NavLink>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col> 
                                        </Row>
                                        

                                        <div className="mt-4">
                                            <h5 className="font-size-14 mb-3">Testimony details: </h5>
                                            <div className="product-desc">
                                                <Nav tabs className="nav-tabs-custom" role="tablist">
                                                    <NavItem>
                                                      <NavLink id="desc-tab"  className={classnames({ active: this.state.activeTab2 === '1' })} onClick={() => { this.toggleTab2('1'); }} >Brief Info</NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                      <NavLink id="specifi-tab" className={classnames({ active: this.state.activeTab2 === '2' })} onClick={() => { this.toggleTab2('2'); }}>Other related data</NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                      <NavLink id="video-text-tab" className={classnames({ active: this.state.activeTab2 === '3' })} onClick={() => { this.toggleTab2('3'); }}>Video Testimony Transcript</NavLink>
                                                    </NavItem>
                                                </Nav>
                                                <TabContent activeTab={this.state.activeTab2} className="border border-top-0 p-4">
                                                    <TabPane tabId="1" role="tabpanel">
                                                        <div>
                                                            <div>
                                                                <p><i className="mdi mdi-circle-medium mr-1 align-middle"></i>Have Traveled Abroad : {this.state.data[5].abroadTavel === 1 ? "Yes" : "No"}</p>
                                                                {this.state.data[5].abroadTavel === 1 && 
                                                                    <p><i className="mdi mdi-circle-medium mr-1 align-middle"></i>Traveled To : {this.state.data[5].visitedCountriesId.map((each, key) => each)}</p>
                                                                }
                                                                <p><i className="mdi mdi-circle-medium mr-1 align-middle"></i>Have Family Abroad : {this.state.data[5].haveFamilyAbroad === 1 ? "Yes" : "No"}</p>
                                                            </div>

                                                            <div>
                                                                <p className="mb-2"><i className="mdi mdi-circle-medium mr-1 align-middle"></i> Chinese Language Skills : {this.state.data[4].chineseLanguageSkills}</p>
                                                                <p className="mb-0"><i className="mdi mdi-circle-medium mr-1 align-middle"></i> Member of The Communist Party : {this.state.data[4].partyMember === 1 ? "Yes" : "No"}</p>


                                                            </div>
                                                        </div>
                                                    </TabPane>
                                                    <TabPane tabId="2" id="specifi" role="tabpanel">
                                                        <div className="table-responsive">
                                                            <Table className="table-nowrap mb-0">
                                                                <tbody>
                                                                    <tr>
                                                                        <th scope="row" style={{width: "400px"}}>Religiosity</th>
                                                                        <td>{this.state.data[4].religiosity}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Educational Level</th>
                                                                        <td>{this.state.data[4].educationLevel}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Marital Status</th>
                                                                        <td>{this.state.data[4].maritalStatus}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Number of Children</th>
                                                                        <td>{this.state.data[4].numberOfChildren}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Occupation</th>
                                                                        <td>{this.state.formOptions.occupations.find(o => o.occupationId === parseInt(this.state.occupationId)).occupationEN}</td>
                                                                        {!this.state.showOccupationEdit ? <td><Button onClick={()=>{this.setState({showOccupationEdit: !this.state.showOccupationEdit})}}>Edit</Button></td> 
                                                                        : <td><Button onClick={()=>{this.setState({showOccupationEdit: !this.state.showOccupationEdit})}}>Cancel</Button></td>
                                                                    }
                                                                    </tr>
                                                                    {this.state.showOccupationEdit ? 
                                                                        <tr>
                                                                            <th scope="row">Occupation</th>
                                                                            <td>
                                                                                <select
                                                                                    className="custom-select"
                                                                                    id="occupationId"
                                                                                    onChange={event => {
                                                                                        this.stateHandling(event);
                                                                                    }}
                                                                                    value={this.state.occupationId}>
                                                                                    {this.state.formOptions.occupations.map((data, id) => (
                                                                                        <option key={id} value={data.occupationId}>
                                                                                            {data.occupationEN}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <Button onClick={this.submitOccupation}>Submit</Button>
                                                                            </td>
                                                                        </tr>
                                                                        : ""
                                                                    }
                                                                    {this.state.occupationSuccess ? <Alert toggle={(e) => this.setState({occupationSuccess: false})} color="success">Successfully Changed!</Alert> : ""}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </TabPane>
                                                    <TabPane tabId="3" id="video-text-tab" role="tabpanel">
                                                        <div>
                                                            {this.state.data[11].map((each, key) => 
                                                                <div>
                                                                    <h3>{each.description}</h3>
                                                                    <p>
                                                                        {each.transcript}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            <p>{this.state.data[11] === undefined || this.state.data[11].length == 0 ? "No video trancript yet" : ""}</p>
                                                        </div>
                                                    </TabPane>
                                                </TabContent>
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <h5 className="font-size-14">Reviews : </h5>
                                            <div className="d-inline-flex mb-3">
                                                <div className="text-muted mr-3">
                                                    <span className="mdi mdi-star text-warning mr-1"></span>
                                                    <span className="mdi mdi-star text-warning mr-1"></span>
                                                    <span className="mdi mdi-star text-warning mr-1"></span>
                                                    <span className="mdi mdi-star text-warning mr-1"></span>
                                                    <span className="mdi mdi-star mr-1"></span>
                                                </div>
                                                <div className="text-muted">( {this.state.data[9].length} Analyst Review)</div>
                                            </div>
                                            <div className="border p-4 rounded">
                                                {this.state.data[9].map((each, key) => 
                                                    <Media className="border-bottom pb-3">
                                                        <Media body>
                                                            <p className="text-muted mb-2">{each.assessment}</p>
                                                            <p className="text-muted mb-2">{each.signature}</p>
                                                            <h5 className="font-size-15 mb-3">{each.note}</h5>

                                                            <ul className="list-inline product-review-link mb-0">
                                                                <li className="list-inline-item">
                                                                    <Link to="#"><i className="mdi mdi-thumb-up align-middle mr-1"></i> Like</Link>
                                                                </li>
                                                                <li className="list-inline-item ml-1">
                                                                    <Link to="#"><i className="mdi mdi-message-text align-middle mr-1"></i> Comment</Link>
                                                                </li>
                                                            </ul>
                                                        </Media>
                                                        <p className="float-sm-right font-size-12"> </p>
                                                    </Media>
                                                )}
                                                <Media>
                                                    <Media body>
                                                        <Link><p className="text-muted mb-2"><AssessmentAdd victimId={this.state.victimId} /></p></Link>
                                                    </Media>
                                                </Media>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col md={12}>
                                                <SourceAdd victimId={this.state.victimId}/>
                                            </Col>
                                            <UiCarousel sources={this.state.data[12]}/>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                        {this.state.data[0].verified ? 
                                            <Col md={4}>
                                                <Media>
                                                    <div className="avatar-sm mr-3">
                                                        <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                                            <i className="ri-checkbox-circle-line"></i>
                                                        </span>
                                                    </div>
                                                    <Media body className="align-self-center overflow-hidden">
                                                        <h5>Verified</h5>
                                                        <p className="text-muted mb-0">This testimony is verified</p>
                                                    </Media>
                                                </Media>
                                            </Col> : ""
                                        }
                                        {this.state.data[8].map((each, index) => 
                                            this.state.data[8][index].accepted ? 
                                                <Col md={4}>
                                                    <Media className="mt-4 mt-md-0">
                                                        <div className="avatar-sm mr-3">
                                                            <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                                                <i className="ri-exchange-line"></i>
                                                            </span>
                                                        </div>
                                                        <Media body className="align-self-center overflow-hidden">
                                                            <h5>{each.consentName}</h5>
                                                            <p className="text-muted mb-0">{each.clarification}</p>
                                                        </Media>
                                                    </Media>
                                                </Col> : ""
                                        )}
                                        </Row>
                                        <Row>
                                            {this.state.showConsentsEdit ? 
                                            <>
                                            <Row>
                                                <Col md={3}>
                                                <div className="form-check mb-2">
                                                    <Input type="checkbox" checked={this.state.data[0].verified} onChange={(event) => this.consentRadioState(event)} name="verified" className="form-check-input input-mini" id="closeButton" value="checked" />
                                                    <Label className="form-check-label" for="closeButton">Verified</Label>
                                                </div>
                                                </Col>
                                                <Col md={3}>
                                                <div className="form-check mb-2">
                                                    <Input type="checkbox" checked={this.state.data[8][0].accepted} onChange={(event) => this.consentRadioState(event)} name="audio" className="form-check-input input-mini" id="debugInfo" value="checked" />
                                                    <Label className="form-check-label" for="debugInfo">Audio Consent</Label>
                                                </div>
                                                </Col>
                                                <Col md={3}>
                                                <div className="form-check mb-2">
                                                    <Input type="checkbox" checked={this.state.data[8][1].accepted} onChange={(event) => this.consentRadioState(event)} name="video" className="form-check-input input-mini" id="progressBar" value="checked" />
                                                    <Label className="form-check-label" for="progressBar">Video Consent</Label>
                                                </div>
                                                </Col>
                                                <Col md={3}>
                                                <div className="form-check mb-2">
                                                    <Input type="checkbox" checked={this.state.data[8][2].accepted} onChange={(event) => this.consentRadioState(event)} name="data" className="form-check-input input-mini" id="preventDuplicates" value="checked" />
                                                    <Label className="form-check-label" for="preventDuplicates">Data Consent</Label>
                                                </div>
                                                </Col>
                                                <Col md={3}>
                                                <div className="form-check mb-2">
                                                    <Input type="checkbox" className="form-check-input input-mini" id="addClear" value="checked" />
                                                    <Label className="form-check-label" for="addClear">Other Consent</Label>
                                                </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Button className="d-flex justify-content-center">Submit</Button>
                                            </Row>
                                            </>
                                                : ""
                                            }
                                            <Col md={10} className="d-flex justify-content-center mt-3">
                                                {this.state.showConsentsEdit ? 
                                                <Button className="d-flex justify-content-center" onClick={() => {this.setState({showConsentsEdit: !this.state.showConsentsEdit})}}>Cancel</Button>
                                                :
                                                <Button className="d-flex justify-content-center" onClick={() => {this.setState({showConsentsEdit: !this.state.showConsentsEdit})}}>Edit</Button>
                                                }
                                            </Col>
                                            {this.state.success ? 
                                            <Col md={10} className="d-flex justify-content-center mt-3">
                                                <Alert color="success" isOpen={this.state.success} toggle={() => {this.setState({success:!this.state.success, successMessage: ""})}}>
                                                    {this.state.successMessage}
                                                </Alert>
                                            </Col>
                                            : ""
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}
}

export default TestimonyDetail;